import React from "react";
import router from "./routes/index";
import { RouterProvider } from "react-router-dom";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const App = () => {
  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <div>
          <RouterProvider router={router} />
        </div>
      </LocalizationProvider>
    </>
  );
};

export default App;
